import React from 'react';

// Attrape toute erreur de rendu React qui laisserait sinon une page blanche :
// affiche l'erreur + la stack à l'écran pour pouvoir diagnostiquer, avec un
// bouton de rechargement.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Erreur de rendu React :', error, info?.componentStack);
    this.setState({ info });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={styles.wrapper}>
        <div style={styles.card}>
          <h1 style={styles.title}>⚠ Une erreur est survenue</h1>
          <p style={styles.subtitle}>
            L'application a planté pendant l'affichage. Détails techniques :
          </p>
          <pre style={styles.pre}>
            {String(this.state.error?.stack || this.state.error)}
            {this.state.info?.componentStack ? `\n\nComposant :${this.state.info.componentStack}` : ''}
          </pre>
          <button onClick={() => window.location.reload()} style={styles.button}>
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}

const styles = {
  wrapper: { minHeight: '100vh', background: '#f4f6f9', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  card: { background: '#fff', borderRadius: 16, padding: 32, maxWidth: 720, width: '100%', boxShadow: '0 8px 24px rgba(0,0,0,0.15)' },
  title: { fontSize: 22, fontWeight: 700, color: '#E46138', marginBottom: 8 },
  subtitle: { fontSize: 14, color: '#7F7F7F', marginBottom: 16 },
  pre: { background: '#062259', color: '#fff', borderRadius: 8, padding: 16, fontSize: 12, overflow: 'auto', maxHeight: 320, whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginBottom: 20 },
  button: { background: '#062259', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
};
